import { IToken } from '@app/src/common/model/AuthModel';

// Email two-factor challenge returned by POST /auth/signin as its second successful outcome.
// The challenge fields are camelCase while the token fields alongside them keep their existing
// snake_case names; they are omitted entirely — not sent as null — when no challenge applies.
export interface IMfaChallenge {
  mfaRequired: boolean;
  challengeId: string;
  maskedEmail: string;
  challengeExpiresIn: number; // seconds of remaining code validity
  resendAfter: number; // seconds to wait before resend; 0 means available now
  codeSent: boolean; // a verification email actually went out for this challenge
  deliveryFailed: boolean; // the initial verification email was not delivered
}

export type ISignInResponse = Partial<IToken> & Partial<IMfaChallenge>;

export interface IMfaResendResponse {
  resendAfter: number;
  challengeExpiresIn: number;
}

// Machine-readable outcomes of signin-verify / signin-resend. Clients match on the code.
export const MfaCodeInvalidCode = 'UM0039'; // carries Data.AttemptsRemaining
export const MfaChallengeExpiredCode = 'UM0040';
export const MfaChallengeLockedCode = 'UM0041';
export const MfaResendThrottledCode = 'UM0042'; // carries Data.RetryAfterSeconds
export const MfaSendFailedCode = 'UM0043';
export const MfaCodeNotSentCode = 'UM0044'; // no code exists yet for this challenge

export interface IMfaErrorEnvelope {
  Code?: string;
  Data?: {
    AttemptsRemaining?: number;
    RetryAfterSeconds?: number;
  };
}
